export const DEFAULT_DARK_COLORS = {
    '--primary-bg': '#0a0a0a',
    '--secondary-bg': '#1a1a1a',
    '--card-bg': '#1f2937',
    '--primary-text': '#e5e7eb',
    '--secondary-text': '#9ca3af',
    '--muted-text': '#6b7280',
    '--sidebar-bg': 'linear-gradient(180deg, #131a24 0%, #131a24 100%)',
    '--border-color': '#2d2d2d',
    '--secondary-border': '#374151',
    '--card-shadow': '0 20px 40px rgba(0, 0, 0, 0.4)',
    '--input-bg': '#0f172a',
    '--primary-orange': '#f97316',
    '--primary-orange-light': 'rgba(249, 115, 22, 0.1)'
};

export const DEFAULT_LIGHT_COLORS = {
    '--primary-bg': '#ffffff',
    '--secondary-bg': '#f5f5f5',
    '--primary-text': '#333333',
    '--secondary-text': '#555555',
    '--sidebar-bg': '#ffffff',
    '--border-color': '#e0e0e0',
    '--card-shadow': '0 2px 8px rgba(0, 0, 0, 0.1)',
};

export function getDarkThemeColors() {
    return JSON.parse(localStorage.getItem('darkThemeColors')) || DEFAULT_DARK_COLORS;
}

export function setDarkThemeColors(colors) {
    localStorage.setItem('darkThemeColors', JSON.stringify(colors));
}

export function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    const colors = theme === 'dark' ? getDarkThemeColors() : DEFAULT_LIGHT_COLORS;
    Object.entries(colors).forEach(([key, val]) => {
        document.documentElement.style.setProperty(key, val);
    });
}